import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconCircleCheck, IconCircleX } from "@tabler/icons-react";
import { ImageConstant, KeyConstant, LangConstant } from "const";
import { BranchUtils, HumpUtils, StorageUtils } from "utils";
import { PageTitle, PaperHeader } from "components";

const License = () => {
  const { t: getLabel } = useTranslation([LangConstant.NS_COMMON, LangConstant.NS_LOGIN]);

  const titleObjectContent = getLabel(LangConstant.OBJ_SIDEBAR_TITLE, { returnObjects: true });
  const branchObj = getLabel(LangConstant.OBJ_TABLE_BRANCH, { returnObjects: true });

  const currentBranchId = StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_ID);

  const [license] = useState({ name: "PJ14", date: "20/05/2023", status: true });
  const [currentBranch, setCurrentBranch] = useState({});

  const RightPaperHeader = () => {
    return (
      <div className="d-flex align-items-center">
        {license.status ? (
          <div className="d-flex align-items-center">
            <span style={{ color: "#CBCACA", fontSize: 15, fontWeight: 600, lineHeight: "20px", marginRight: 10 }}>
              {getLabel(LangConstant.L_ACTIVE)}
            </span>
            <IconCircleCheck size={24} color="green" />
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <span style={{ color: "#CBCACA", fontSize: 15, fontWeight: 600, lineHeight: "20px", marginRight: 10 }}>
              {getLabel(LangConstant.L_EXPIRED)}
            </span>
            <IconCircleX size={24} color="red" />
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    setCurrentBranch(HumpUtils.camelizeKeys(BranchUtils.getCurrentBranch()));
  }, [currentBranchId]);

  return (
    <Fragment>
      <PageTitle>{titleObjectContent.license}</PageTitle>
      <div className="card" style={{ padding: "28px 36px", marginBottom: 16 }}>
        <div className="card-body p-0">
          <PaperHeader
            icon={<ImageConstant.UserTagIcon style={{ width: 36, height: 23 }} />}
            title={getLabel(LangConstant.L_ACTIVATION_STATE)}
            rightEl={<RightPaperHeader />}
          />
          <div className="d-flex justify-content-between" style={{ margin: "10px 0" }}>
            <span style={{ fontSize: 15 }}>{branchObj.license}</span>
            <span style={{ fontSize: 15 }}>{currentBranch.license}</span>
          </div>
          <div className="d-flex justify-content-between" style={{ margin: "10px 0" }}>
            <span style={{ fontSize: 15 }}>{branchObj.package}</span>
            <span style={{ fontSize: 15 }}>{currentBranch.package}</span>
          </div>
          <div className="d-flex justify-content-between" style={{ margin: "10px 0" }}>
            <span style={{ fontSize: 15 }}>{branchObj.packageId}</span>
            <span style={{ fontSize: 15 }}>{currentBranch.packageId}</span>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default License;
